/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const videos = makeEntityScaffold('SAGA.API.VIDEOS', (client, filters, options = { brackets: true }) =>
  client.videos.getVideosList(filters, options)
);

export const onDemandVideos = makeEntityScaffold('SAGA.API.ON_DEMAND_VIDEOS', (client, options = {}) =>
  client.videos.getOnDemandVideos(options)
);

export const videoCollection = makeEntityScaffold(
  'SAGA.API.VIDEO_COLLECTION',
  (client, collectionType, collectionName, flags, options = {}) =>
    client.videos.getCollectionsByName(collectionType, collectionName, flags, options)
);

export const videoStacks = makeEntityScaffold('SAGA.API.VIDEO_STACKS', (client, options = {}) =>
  // Massage cards data to match video details
  client.videos.getStacks(options).then(res =>
    res.stacks.map(stack => ({
      ...stack,
      cards: stack.cards.map(card => {
        card.instructor = card.subtitle || card.instructor;
        card.thumbnail_large_url = card.image_path;
        card.partner = { alias: card.partner_alias };
        return card;
      }),
    }))
  )
);

export const videoDetails = makeEntityScaffold(
  'SAGA.API.VIDEO_DETAILS',
  (client, partnerAlias, videoAlias, options = {}) =>
    client.videos
      .getVideoIdByLookup(
        {
          partner_alias: partnerAlias,
          video_alias: videoAlias,
        },
        options
      )
      .then(lookup =>
        client.videos.getVideoById(lookup.id, { cp_home_beta: true, brightcove: true }).then(data => {
          const streamUrl = data.stream_url || `https://player.ooyala.com/player/appletv/${data.content_id}.m3u8`;
          return {
            ...data,
            stream_url: streamUrl,
          };
        })
      ),
  { defaultKey: 2 }
);

export const videoBookmarks = makeEntityScaffold('SAGA.API.VIDEO_BOOKMARKS', (client, userId, options = {}) =>
  client.videos.getUserVideoBookmarks(userId, options)
);

export const videosFilters = makeEntityScaffold('SAGA.API.VIDEO_FILTERS', (client, options = { app: 'web' }) =>
  client.videos.getVideosFilters(options)
);

export const videoViewRatings = makeEntityScaffold('SAGA.API.VIDEO_VIEW_RATINGS', (client, userId, options = {}) =>
  client.videos.getVideoViewRatings(userId, { ratings_type: 'pending' }, options)
);

export const videoTracking = makeEntityScaffold('SAGA.API.VIDEO_TRACKING', (client, userId, options = {}) =>
  client.videos.videoEvents(userId, options).then(data => ({ video_id: options.video_id, ...data }))
);

export const videoCompletedViews = makeEntityScaffold(
  'SAGA.API.VIDEO_COMPLETED_VIEWS',
  (client, userId, options = { view_type: 'completed' }) => client.videos.getViewedVideos(userId, options)
);

export const liveVideos = makeEntityScaffold('SAGA.API.LIVE_VIDEOS', (client, options = {}) =>
  client.videos.getLiveVideos(options)
);

export const liveVideoDetail = makeEntityScaffold(
  'SAGA.API.LIVE_VIDEO_DETAILS',
  (client, alias, options = {}) => client.videos.getLiveVideosById(alias, options),
  { defaultKey: 1 }
);
